import React from "react";

interface NotificationPopupProps {
    title: string;
    body: string;
    onClose: () => void;
}

const NotificationPopup: React.FC<NotificationPopupProps> = ({ title, body, onClose }) => {
    return (
        <div className="fixed top-5 right-5 z-[9999]">
            <div className="bg-white shadow-lg rounded-lg p-4 w-80 border border-gray-200">
                <div className="flex justify-between items-start">
                    <div>
                        <h4 className="font-bold text-primary mb-1">{title}</h4>
                        <p className="text-sm text-gray-600">{body}</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="ml-2 text-gray-400 hover:text-gray-600 font-bold"
                    >
                        ✕
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;
